export default {
	 bookingnum:state => state.bookingnum,
	 commennum:state => state.commennum,
}


// WEBPACK FOOTER //
// ./src/store/getters.js